import React, { useEffect, useCallback, useRef } from "react";
import { ToastBar } from "react-hot-toast";

const SessionTimeout = ({ isLoggedIn, handleLogout, timeoutDuration }) => {
  const inactivityTimer = useRef(null);

  const resetInactivityTimer = useCallback(() => {
    if (isLoggedIn) {
      localStorage.setItem("lastActivity", new Date().getTime());

      if (inactivityTimer.current) {
        clearTimeout(inactivityTimer.current);
      }

      inactivityTimer.current = setTimeout(() => {
        handleLogout();
      }, timeoutDuration);
    }
  }, [isLoggedIn, handleLogout, timeoutDuration]);

  useEffect(() => {
    if (!isLoggedIn) return;

    const handleInactive = () => {
      const lastActivity = localStorage.getItem("lastActivity");
      const currentTime = new Date().getTime();

      if (lastActivity && currentTime - lastActivity > timeoutDuration) {
        handleLogout();
      }
    };

    const handleUserActivity = () => {
      resetInactivityTimer();
    };

    resetInactivityTimer();
    const checkInactivityInterval = setInterval(handleInactive, 5000);

    window.addEventListener("mousemove", handleUserActivity);
    window.addEventListener("keypress", handleUserActivity);
    window.addEventListener("scroll", handleUserActivity);

    return () => {
      clearTimeout(inactivityTimer.current);
      clearInterval(checkInactivityInterval);
      window.removeEventListener("mousemove", handleUserActivity);
      window.removeEventListener("keypress", handleUserActivity);
      window.removeEventListener("scroll", handleUserActivity);
    };
  }, [isLoggedIn, resetInactivityTimer, timeoutDuration, handleLogout]);
  return null;
};

export default SessionTimeout;
